import { Button } from '@mui/material';
import { LadyIcon } from 'assets/Icons/LadyIcon';
import { useTranslation } from 'react-i18next';

export default function SuccessManager() {
  const { t } = useTranslation();

  return (
    <>
      <div className='basis-[30%] hidden xl:block rounded-3xl bg-[#F4F6F8] text-center justify-center p-8'>
        <LadyIcon />
        <h5 className='mt-4'>
          {t('need_help_success')} <br /> {t('success_manager')}
        </h5>

        <Button
          variant='outlined'
          className='mt-4'
          target='_blank'
          href='https://makewebbetter.com/contact-us/?utm_source=app&utm_medium=mwb&utm_campaign=formpay'
        >
          {t('contact_now')}
        </Button>
        <div className='text-left mt-10'>
          <h5 className='mt-4'>{t('Instructions')} :</h5>
          <div className='text-gray-500 text-xs my-2'>
            1. {t('add_your_hubspot_portal')}
          </div>
          <div className='text-gray-500 text-xs my-2'>
            2. {t('select_the_portal_you_want_to_connect')}
          </div>
          <div className='text-gray-500 text-xs my-2'>
            3. {t('setup_payment_gateways')}
          </div>
          <div className='text-gray-500 text-xs my-2'>
            4. {t('create_configure_forms')}
          </div>
        </div>
      </div>
    </>
  );
}
